module.exports = __webpack_public_path__ + "static/industrial-troubleshooting-of-lighting-wiring-systems-ca2fee251d7c7529cca73149470ad791.jpg";